import React, { useCallback, useMemo, useState, memo } from 'react';
import Icon from 'choerodon-ui/lib/icon';
import TextField from '../../text-field';
import CheckBox from '../../check-box';
import { $l } from '../../locale-context';
const ComboFieldList = function ComboFieldList({ value, onSelect, onUnSelect, groups, prefixCls, fieldsLimit }) {
    const [searchText, setSearchText] = useState('');
    const labelCodes = useMemo(() => groups.reduce((res, current) => [...res, ...current.fields.map((o) => [o.get('name'), o.get('label')])], []), [groups]);
    const isChecked = useCallback((code) => value.includes(code), [value]);
    const handleChange = useCallback((code, select) => {
        if (select) {
            onSelect(code);
        }
        else {
            onUnSelect(code);
        }
    }, [onSelect, onUnSelect]);
    const renderGroup = useCallback((group) => group.fields.length > 0 && (React.createElement("div", { className: `${prefixCls}-section`, key: group.title },
        React.createElement("div", { className: `${prefixCls}-list` }, group.fields.map((field) => {
            const code = field.get('name');
            const label = field.get('label');
            const checked = isChecked(code);
            if (label && label.includes(searchText || '')) {
                return (React.createElement("div", { className: `${prefixCls}-item`, key: code },
                    React.createElement(CheckBox, { value: code, disabled: field.get('disabled'), checked: checked, onChange: () => handleChange(code, !checked) }, label)));
            }
            return null;
        })))), [handleChange, isChecked, searchText]);
    const chooseRe = () => {
        const allValue = labelCodes.map(lc => {
            if (lc[1] && lc[1].includes(searchText || '')) {
                return lc[0];
            }
            return undefined;
        }).filter(v => !!v);
        const selected = value.slice(fieldsLimit);
        const reSelectedOptions = allValue.filter((i) => {
            const optionIsSelect = selected.some((v) => {
                return v === i;
            });
            return !optionIsSelect;
        });
        handleChange(selected, false);
        handleChange(reSelectedOptions, true);
    };
    return (React.createElement("div", { className: prefixCls },
        React.createElement("div", { className: `${prefixCls}-search` },
            React.createElement(TextField, { style: { flex: 1 }, value: searchText, onClick: (e) => {
                    e.preventDefault();
                    e.currentTarget.focus();
                }, onChange: (v) => {
                    setSearchText(v);
                }, onInput: (e) => {
                    setSearchText(e.target.value);
                }, prefix: React.createElement(Icon, { type: "search" }), placeholder: $l('Table', 'enter_search_filter'), clearButton: true })),
        React.createElement("div", { className: `${prefixCls}-header` },
            React.createElement("span", { className: `${prefixCls}-search-action`, onClick: () => {
                    const values = labelCodes.map(lc => {
                        if (lc[1] && lc[1].includes(searchText || '')) {
                            return lc[0];
                        }
                        return undefined;
                    }).filter(v => !!v);
                    handleChange(values, true);
                } }, $l('Select', 'select_all')),
            React.createElement("span", { className: `${prefixCls}-search-action`, onClick: chooseRe }, $l('Select', 'select_re')),
            React.createElement("span", { className: `${prefixCls}-search-action`, onClick: () => {
                    const values = labelCodes.map(lc => {
                        if (lc[1] && lc[1].includes(searchText || '')) {
                            return lc[0];
                        }
                        return undefined;
                    }).filter(v => !!v);
                    handleChange(values, false);
                } }, $l('Table', 'clear'))),
        React.createElement("div", { className: `${prefixCls}-content` }, groups.map((group) => renderGroup(group)))));
};
ComboFieldList.displayName = 'ComboFieldList';
export default memo(ComboFieldList);
